<script setup>
import { ref, computed, provide, watch } from "vue"
import PHeading from "@/components/PHeading.vue"
import PNewTrialSubscription from "@/components/PNewTrialSubscription.vue"
import { useAccount } from "@/composables/useAccount.js"

const searchInput = ref("")
const throttledInput = ref("")
let timeout
watch(searchInput, (val) => {
  // I have to throttle the update of input field value because it would
  // else be very costly and results in a laggy UI because of too many
  // UI re-renders.
  clearTimeout(timeout)

  timeout = setTimeout(() => {
    throttledInput.value = val
    clearTimeout(timeout)
  }, 1000)
})

const searchTerms = computed(() =>
  throttledInput.value
    .toLowerCase()
    .split(",")
    .map(w => w.trim()),
)
provide("searchInputFromOverview", { searchInput: throttledInput, searchTerms })

const toggleBtn = ref(0)
const resetComponentKey = ref(Date.now())
const { user } = useAccount()
</script>

<template>
  <v-container>
    <p-heading disable-navigation>
      <template #icon>
        $mdiViewDashboard
      </template>
      subscription overview
      <v-spacer />
      <p-new-trial-subscription
        :key="resetComponentKey"
        @close="resetComponentKey = Date.now()"
      />
    </p-heading>

    <v-card class="mb-4">
      <v-card-title>
        <v-text-field
          v-model.trim="searchInput"
          prepend-inner-icon="$mdiMagnify"
          :label="`Search by comma separated strings`.toUpperCase()"
          placeholder="e. g. test@e-mail.com, Example Inc., Hosted 500"
          hide-details
        >
          <template
            v-if="user.role !== 'distributor'"
            #append
          >
            <v-btn-toggle
              v-model="toggleBtn"
              variant="text"
              density="compact"
            >
              <v-btn
                icon
                to="/overview"
                exact
              >
                <v-icon>
                  $mdiCardBulletedOutline
                </v-icon>
                <v-tooltip
                  activator="parent"
                  location="bottom"
                >
                  Card view
                </v-tooltip>
              </v-btn>
              <v-btn
                icon
                to="/overview/table"
                exact
              >
                <v-icon>
                  $mdiTable
                </v-icon>
                <v-tooltip
                  activator="parent"
                  location="bottom"
                >
                  Table view
                </v-tooltip>
              </v-btn>
            </v-btn-toggle>
          </template>
        </v-text-field>
      </v-card-title>
    </v-card>

    <router-view v-slot="{ Component, route }">
      <v-slide-x-transition mode="out-in">
        <component
          :is="Component"
          :key="route.name"
        />
      </v-slide-x-transition>
    </router-view>
  </v-container>
</template>
